<div class="sidesheet" [class.sidesheet--open]="open()">
  <dv-button class="sidesheet__close-btn" icon="close" (click)="onClose()"></dv-button>

  <div class="sidesheet__content">
    <ng-content />
  </div>
</div>
